import {GetStoreServiceApiResponse} from "../../../../react-query-hooks/store/services/get-store-service/types";
import {useGetStoreServiceContext} from "../../../../service-feature/useCases/edit-service/context/get-store-service";
import {StoreServiceCustomerInsights} from "./customers-section";
import {StoreServiceSalesAndInsightsRevenueSection} from "./revenue-section";

export type StoreServiceSalesAndInsightsProps = {
  serviceData: GetStoreServiceApiResponse;
};

export function StoreServiceSalesAndInsights() {
  const {
    state: {
      storeServiceData: {
        productService: {id, name, createdAt},
      },
    },
  } = useGetStoreServiceContext();
  return (
    <div>
      <StoreServiceSalesAndInsightsRevenueSection storeServiceId={id} />
      <StoreServiceCustomerInsights
        storeServiceId={id}
        storeServiceTitle={name}
        serviceCreatedAt={createdAt}
      />
    </div>
  );
}
